import Booking from "../../entity/booking";

var BookingService = function () {

    "use strict";

    var self = this;
    this.booking = new Booking();

};

export default BookingService;